import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Form } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import { Guardian } from '@xaamin/guardian';

class EmpresaInfoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
      data: {}
    }
  }

  get rules() {
    return {
      'nombre': ['required', 'string', 'min:2'],
      'host': ['string', 'min:5', 'max:200'],
    }
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data.nombre) {
      this.handleOnChange({});
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const { data, autoFocus } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Nombre"
          name="nombre"
          placeholder=""
          help=""
          autoFocus={ autoFocus }
          validator={ validator }
          value={ data.nombre }
          onChange={ this.handleOnChange }
        />

        { Guardian.allows('root.access') && (
          <>
            <FormControl type="text"
              label="Host"
              name="host"
              placeholder="autofacturacion.example.test"
              help="Se usará para el módulo de autofacturación, omitir el https://"
              validator={ validator }
              value={ data.host }
              onChange={ this.handleOnChange }
            />

            <FormControl as="textarea"
              label="Configuración"
              name="config"
              rows="10"
              placeholder=""
              help="Se usará en todo el sistema para configurar servicios, úsalo con precaución y evita cometer errores =)"
              validator={ validator }
              value={ typeof data.config === 'object' ? JSON.stringify(data.config, undefined, 4) : data.config }
              onChange={ this.handleOnChange }
            />
          </>
        )}

      </Form>
    )
  }
}

export default EmpresaInfoForm;